<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like to thank my husband, Steve, and my children for their love and support during the writing of this book.</p>
<p>“It has been said, ‘Time heals all wounds.’ I do not agree. The wounds remain. In time, the mind, protecting its sanity, covers them with scar tissue and the pain lessens. But it is never gone.”</p>
<blockquote>
<p>― Rose Fitzgerald Kennedy</p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?7b678f4e